import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1f8bf3c8 = () => interopDefault(import('../pages/ad.vue' /* webpackChunkName: "pages/ad" */))
const _c1cef0c2 = () => interopDefault(import('../pages/ad/index.vue' /* webpackChunkName: "pages/ad/index" */))
const _dca6ec8e = () => interopDefault(import('../pages/show/index.vue' /* webpackChunkName: "" */))
const _2cdd59e9 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d1e1e4a8 = () => interopDefault(import('../pages/index/index.vue' /* webpackChunkName: "pages/index/index" */))
const _7d38333c = () => interopDefault(import('../pages/bigo-streamer.vue' /* webpackChunkName: "pages/bigo-streamer" */))
const _2f646186 = () => interopDefault(import('../pages/classify.vue' /* webpackChunkName: "pages/classify" */))
const _d9c19800 = () => interopDefault(import('../pages/classify/index.vue' /* webpackChunkName: "pages/classify/index" */))
const _61a1fe6a = () => interopDefault(import('../pages/crushme.vue' /* webpackChunkName: "pages/crushme" */))
const _4ecc8d6d = () => interopDefault(import('../pages/crushme/index.vue' /* webpackChunkName: "pages/crushme/index" */))
const _cc925750 = () => interopDefault(import('../pages/games.vue' /* webpackChunkName: "pages/games" */))
const _358e8e4a = () => interopDefault(import('../pages/games/index.vue' /* webpackChunkName: "pages/games/index" */))
const _11c53603 = () => interopDefault(import('../pages/games/_id.vue' /* webpackChunkName: "pages/games/_id" */))
const _003ebdbf = () => interopDefault(import('../pages/jp.vue' /* webpackChunkName: "pages/jp" */))
const _41e08dfc = () => interopDefault(import('../pages/jp/index.vue' /* webpackChunkName: "pages/jp/index" */))
const _c8feba44 = () => interopDefault(import('../pages/jp/about-us.vue' /* webpackChunkName: "pages/jp/about-us" */))
const _7e97262a = () => interopDefault(import('../pages/jp/contact-us.vue' /* webpackChunkName: "pages/jp/contact-us" */))
const _6ae30e96 = () => interopDefault(import('../pages/jp/news/index.vue' /* webpackChunkName: "pages/jp/news/index" */))
const _77efbe7e = () => interopDefault(import('../pages/jp/news/_id.vue' /* webpackChunkName: "pages/jp/news/_id" */))
const _07b0a383 = () => interopDefault(import('../pages/jp2.vue' /* webpackChunkName: "pages/jp2" */))
const _41073bc6 = () => interopDefault(import('../pages/jp2/index.vue' /* webpackChunkName: "pages/jp2/index" */))
const _5a1823b6 = () => interopDefault(import('../pages/show.vue' /* webpackChunkName: "pages/show" */))
const _67c15c6a = () => interopDefault(import('../pages/ssrmobile.vue' /* webpackChunkName: "pages/ssrmobile" */))
const _5007d7e4 = () => interopDefault(import('../pages/ssrmobile/index.vue' /* webpackChunkName: "pages/ssrmobile/index" */))
const _7c2fdbe2 = () => interopDefault(import('../pages/ssrmobile/room/game.vue' /* webpackChunkName: "pages/ssrmobile/room/game" */))
const _12ab094d = () => interopDefault(import('../pages/ssrmobile/room/mixins.js' /* webpackChunkName: "pages/ssrmobile/room/mixins" */))
const _5d1e2526 = () => interopDefault(import('../pages/ssrmobile/room/show.vue' /* webpackChunkName: "pages/ssrmobile/room/show" */))
const _ec543e2c = () => interopDefault(import('../pages/ssrmobile/user/_id.vue' /* webpackChunkName: "pages/ssrmobile/user/_id" */))
const _725bb279 = () => interopDefault(import('../pages/userCenter.vue' /* webpackChunkName: "pages/userCenter" */))
const _d81d9ce0 = () => interopDefault(import('../pages/userCenter/edit.vue' /* webpackChunkName: "pages/userCenter/edit" */))
const _6981f78c = () => interopDefault(import('../pages/userCenter/setting.vue' /* webpackChunkName: "pages/userCenter/setting" */))
const _329c1ba4 = () => interopDefault(import('../pages/userCenter/_id.vue' /* webpackChunkName: "pages/userCenter/_id" */))
const _631ef7c0 = () => interopDefault(import('../pages/_bigoid.vue' /* webpackChunkName: "" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___en___default"
    }]
  }, {
    path: "/all",
    component: _dca6ec8e,
    name: "all___en___default"
  }, {
    path: "/ar",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ar"
    }]
  }, {
    path: "/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___en___default"
  }, {
    path: "/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___en___default"
    }]
  }, {
    path: "/cn",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___cn"
    }]
  }, {
    path: "/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___en___default"
    }]
  }, {
    path: "/de",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___de"
    }]
  }, {
    path: "/en",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___en"
    }]
  }, {
    path: "/es",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___es"
    }]
  }, {
    path: "/fr",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___fr"
    }]
  }, {
    path: "/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___en___default"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___en___default"
    }]
  }, {
    path: "/hi",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___hi"
    }]
  }, {
    path: "/id",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___id"
    }]
  }, {
    path: "/it",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___it"
    }]
  }, {
    path: "/ja",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ja"
    }]
  }, {
    path: "/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___en___default"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___en___default"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___en___default"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___en___default"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___en___default"
    }]
  }, {
    path: "/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___en___default"
    }]
  }, {
    path: "/ko",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ko"
    }]
  }, {
    path: "/mm",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___mm"
    }]
  }, {
    path: "/ms",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ms"
    }]
  }, {
    path: "/nl",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___nl"
    }]
  }, {
    path: "/pl",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___pl"
    }]
  }, {
    path: "/pt",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___pt"
    }]
  }, {
    path: "/ro",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ro"
    }]
  }, {
    path: "/ru",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___ru"
    }]
  }, {
    path: "/se",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___se"
    }]
  }, {
    path: "/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___en___default"
    }]
  }, {
    path: "/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___en___default"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___en___default"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___en___default"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___en___default"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___en___default"
    }]
  }, {
    path: "/th",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___th"
    }]
  }, {
    path: "/tr",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___tr"
    }]
  }, {
    path: "/tw",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___tw"
    }]
  }, {
    path: "/userCenter",
    component: _725bb279,
    name: "userCenter___en___default",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___en___default"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___en___default"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___en___default"
    }]
  }, {
    path: "/vi",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___vi"
    }]
  }, {
    path: "/ar/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ar"
    }]
  }, {
    path: "/ar/all",
    component: _dca6ec8e,
    name: "all___ar"
  }, {
    path: "/ar/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ar"
  }, {
    path: "/ar/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ar"
    }]
  }, {
    path: "/ar/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ar"
    }]
  }, {
    path: "/ar/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ar"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ar"
    }]
  }, {
    path: "/ar/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ar"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ar"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ar"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ar"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ar"
    }]
  }, {
    path: "/ar/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ar"
    }]
  }, {
    path: "/ar/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ar"
    }]
  }, {
    path: "/ar/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ar"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ar"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ar"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ar"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ar"
    }]
  }, {
    path: "/ar/userCenter",
    component: _725bb279,
    name: "userCenter___ar",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ar"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ar"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ar"
    }]
  }, {
    path: "/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___en___default"
  }, {
    path: "/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___en___default"
  }, {
    path: "/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___en___default"
  }, {
    path: "/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___en___default"
  }, {
    path: "/cn/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___cn"
    }]
  }, {
    path: "/cn/all",
    component: _dca6ec8e,
    name: "all___cn"
  }, {
    path: "/cn/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___cn"
  }, {
    path: "/cn/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___cn"
    }]
  }, {
    path: "/cn/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___cn"
    }]
  }, {
    path: "/cn/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___cn"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___cn"
    }]
  }, {
    path: "/cn/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___cn"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___cn"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___cn"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___cn"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___cn"
    }]
  }, {
    path: "/cn/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___cn"
    }]
  }, {
    path: "/cn/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___cn"
    }]
  }, {
    path: "/cn/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___cn"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___cn"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___cn"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___cn"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___cn"
    }]
  }, {
    path: "/cn/userCenter",
    component: _725bb279,
    name: "userCenter___cn",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___cn"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___cn"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___cn"
    }]
  }, {
    path: "/de/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___de"
    }]
  }, {
    path: "/de/all",
    component: _dca6ec8e,
    name: "all___de"
  }, {
    path: "/de/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___de"
  }, {
    path: "/de/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___de"
    }]
  }, {
    path: "/de/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___de"
    }]
  }, {
    path: "/de/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___de"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___de"
    }]
  }, {
    path: "/de/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___de"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___de"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___de"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___de"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___de"
    }]
  }, {
    path: "/de/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___de"
    }]
  }, {
    path: "/de/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___de"
    }]
  }, {
    path: "/de/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___de"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___de"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___de"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___de"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___de"
    }]
  }, {
    path: "/de/userCenter",
    component: _725bb279,
    name: "userCenter___de",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___de"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___de"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___de"
    }]
  }, {
    path: "/en/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___en"
    }]
  }, {
    path: "/en/all",
    component: _dca6ec8e,
    name: "all___en"
  }, {
    path: "/en/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___en"
  }, {
    path: "/en/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___en"
    }]
  }, {
    path: "/en/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___en"
    }]
  }, {
    path: "/en/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___en"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___en"
    }]
  }, {
    path: "/en/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___en"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___en"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___en"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___en"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___en"
    }]
  }, {
    path: "/en/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___en"
    }]
  }, {
    path: "/en/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___en"
    }]
  }, {
    path: "/en/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___en"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___en"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___en"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___en"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___en"
    }]
  }, {
    path: "/en/userCenter",
    component: _725bb279,
    name: "userCenter___en",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___en"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___en"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___en"
    }]
  }, {
    path: "/es/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___es"
    }]
  }, {
    path: "/es/all",
    component: _dca6ec8e,
    name: "all___es"
  }, {
    path: "/es/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___es"
  }, {
    path: "/es/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___es"
    }]
  }, {
    path: "/es/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___es"
    }]
  }, {
    path: "/es/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___es"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___es"
    }]
  }, {
    path: "/es/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___es"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___es"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___es"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___es"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___es"
    }]
  }, {
    path: "/es/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___es"
    }]
  }, {
    path: "/es/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___es"
    }]
  }, {
    path: "/es/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___es"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___es"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___es"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___es"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___es"
    }]
  }, {
    path: "/es/userCenter",
    component: _725bb279,
    name: "userCenter___es",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___es"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___es"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___es"
    }]
  }, {
    path: "/fr/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___fr"
    }]
  }, {
    path: "/fr/all",
    component: _dca6ec8e,
    name: "all___fr"
  }, {
    path: "/fr/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___fr"
  }, {
    path: "/fr/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___fr"
    }]
  }, {
    path: "/fr/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___fr"
    }]
  }, {
    path: "/fr/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___fr"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___fr"
    }]
  }, {
    path: "/fr/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___fr"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___fr"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___fr"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___fr"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___fr"
    }]
  }, {
    path: "/fr/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___fr"
    }]
  }, {
    path: "/fr/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___fr"
    }]
  }, {
    path: "/fr/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___fr"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___fr"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___fr"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___fr"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___fr"
    }]
  }, {
    path: "/fr/userCenter",
    component: _725bb279,
    name: "userCenter___fr",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___fr"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___fr"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___fr"
    }]
  }, {
    path: "/hi/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___hi"
    }]
  }, {
    path: "/hi/all",
    component: _dca6ec8e,
    name: "all___hi"
  }, {
    path: "/hi/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___hi"
  }, {
    path: "/hi/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___hi"
    }]
  }, {
    path: "/hi/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___hi"
    }]
  }, {
    path: "/hi/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___hi"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___hi"
    }]
  }, {
    path: "/hi/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___hi"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___hi"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___hi"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___hi"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___hi"
    }]
  }, {
    path: "/hi/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___hi"
    }]
  }, {
    path: "/hi/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___hi"
    }]
  }, {
    path: "/hi/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___hi"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___hi"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___hi"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___hi"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___hi"
    }]
  }, {
    path: "/hi/userCenter",
    component: _725bb279,
    name: "userCenter___hi",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___hi"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___hi"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___hi"
    }]
  }, {
    path: "/id/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___id"
    }]
  }, {
    path: "/id/all",
    component: _dca6ec8e,
    name: "all___id"
  }, {
    path: "/id/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___id"
  }, {
    path: "/id/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___id"
    }]
  }, {
    path: "/id/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___id"
    }]
  }, {
    path: "/id/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___id"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___id"
    }]
  }, {
    path: "/id/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___id"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___id"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___id"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___id"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___id"
    }]
  }, {
    path: "/id/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___id"
    }]
  }, {
    path: "/id/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___id"
    }]
  }, {
    path: "/id/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___id"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___id"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___id"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___id"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___id"
    }]
  }, {
    path: "/id/userCenter",
    component: _725bb279,
    name: "userCenter___id",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___id"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___id"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___id"
    }]
  }, {
    path: "/it/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___it"
    }]
  }, {
    path: "/it/all",
    component: _dca6ec8e,
    name: "all___it"
  }, {
    path: "/it/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___it"
  }, {
    path: "/it/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___it"
    }]
  }, {
    path: "/it/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___it"
    }]
  }, {
    path: "/it/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___it"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___it"
    }]
  }, {
    path: "/it/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___it"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___it"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___it"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___it"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___it"
    }]
  }, {
    path: "/it/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___it"
    }]
  }, {
    path: "/it/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___it"
    }]
  }, {
    path: "/it/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___it"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___it"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___it"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___it"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___it"
    }]
  }, {
    path: "/it/userCenter",
    component: _725bb279,
    name: "userCenter___it",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___it"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___it"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___it"
    }]
  }, {
    path: "/ja/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ja"
    }]
  }, {
    path: "/ja/all",
    component: _dca6ec8e,
    name: "all___ja"
  }, {
    path: "/ja/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ja"
  }, {
    path: "/ja/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ja"
    }]
  }, {
    path: "/ja/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ja"
    }]
  }, {
    path: "/ja/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ja"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ja"
    }]
  }, {
    path: "/ja/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ja"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ja"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ja"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ja"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ja"
    }]
  }, {
    path: "/ja/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ja"
    }]
  }, {
    path: "/ja/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ja"
    }]
  }, {
    path: "/ja/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ja"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ja"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ja"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ja"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ja"
    }]
  }, {
    path: "/ja/userCenter",
    component: _725bb279,
    name: "userCenter___ja",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ja"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ja"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ja"
    }]
  }, {
    path: "/ko/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ko"
    }]
  }, {
    path: "/ko/all",
    component: _dca6ec8e,
    name: "all___ko"
  }, {
    path: "/ko/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ko"
  }, {
    path: "/ko/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ko"
    }]
  }, {
    path: "/ko/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ko"
    }]
  }, {
    path: "/ko/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ko"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ko"
    }]
  }, {
    path: "/ko/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ko"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ko"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ko"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ko"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ko"
    }]
  }, {
    path: "/ko/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ko"
    }]
  }, {
    path: "/ko/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ko"
    }]
  }, {
    path: "/ko/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ko"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ko"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ko"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ko"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ko"
    }]
  }, {
    path: "/ko/userCenter",
    component: _725bb279,
    name: "userCenter___ko",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ko"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ko"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ko"
    }]
  }, {
    path: "/mm/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___mm"
    }]
  }, {
    path: "/mm/all",
    component: _dca6ec8e,
    name: "all___mm"
  }, {
    path: "/mm/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___mm"
  }, {
    path: "/mm/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___mm"
    }]
  }, {
    path: "/mm/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___mm"
    }]
  }, {
    path: "/mm/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___mm"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___mm"
    }]
  }, {
    path: "/mm/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___mm"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___mm"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___mm"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___mm"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___mm"
    }]
  }, {
    path: "/mm/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___mm"
    }]
  }, {
    path: "/mm/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___mm"
    }]
  }, {
    path: "/mm/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___mm"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___mm"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___mm"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___mm"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___mm"
    }]
  }, {
    path: "/mm/userCenter",
    component: _725bb279,
    name: "userCenter___mm",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___mm"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___mm"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___mm"
    }]
  }, {
    path: "/ms/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ms"
    }]
  }, {
    path: "/ms/all",
    component: _dca6ec8e,
    name: "all___ms"
  }, {
    path: "/ms/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ms"
  }, {
    path: "/ms/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ms"
    }]
  }, {
    path: "/ms/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ms"
    }]
  }, {
    path: "/ms/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ms"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ms"
    }]
  }, {
    path: "/ms/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ms"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ms"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ms"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ms"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ms"
    }]
  }, {
    path: "/ms/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ms"
    }]
  }, {
    path: "/ms/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ms"
    }]
  }, {
    path: "/ms/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ms"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ms"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ms"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ms"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ms"
    }]
  }, {
    path: "/ms/userCenter",
    component: _725bb279,
    name: "userCenter___ms",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ms"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ms"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ms"
    }]
  }, {
    path: "/nl/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___nl"
    }]
  }, {
    path: "/nl/all",
    component: _dca6ec8e,
    name: "all___nl"
  }, {
    path: "/nl/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___nl"
  }, {
    path: "/nl/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___nl"
    }]
  }, {
    path: "/nl/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___nl"
    }]
  }, {
    path: "/nl/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___nl"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___nl"
    }]
  }, {
    path: "/nl/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___nl"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___nl"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___nl"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___nl"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___nl"
    }]
  }, {
    path: "/nl/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___nl"
    }]
  }, {
    path: "/nl/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___nl"
    }]
  }, {
    path: "/nl/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___nl"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___nl"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___nl"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___nl"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___nl"
    }]
  }, {
    path: "/nl/userCenter",
    component: _725bb279,
    name: "userCenter___nl",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___nl"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___nl"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___nl"
    }]
  }, {
    path: "/pl/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___pl"
    }]
  }, {
    path: "/pl/all",
    component: _dca6ec8e,
    name: "all___pl"
  }, {
    path: "/pl/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___pl"
  }, {
    path: "/pl/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___pl"
    }]
  }, {
    path: "/pl/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___pl"
    }]
  }, {
    path: "/pl/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___pl"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___pl"
    }]
  }, {
    path: "/pl/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___pl"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___pl"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___pl"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___pl"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___pl"
    }]
  }, {
    path: "/pl/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___pl"
    }]
  }, {
    path: "/pl/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___pl"
    }]
  }, {
    path: "/pl/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___pl"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___pl"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___pl"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___pl"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___pl"
    }]
  }, {
    path: "/pl/userCenter",
    component: _725bb279,
    name: "userCenter___pl",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___pl"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___pl"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___pl"
    }]
  }, {
    path: "/pt/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___pt"
    }]
  }, {
    path: "/pt/all",
    component: _dca6ec8e,
    name: "all___pt"
  }, {
    path: "/pt/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___pt"
  }, {
    path: "/pt/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___pt"
    }]
  }, {
    path: "/pt/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___pt"
    }]
  }, {
    path: "/pt/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___pt"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___pt"
    }]
  }, {
    path: "/pt/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___pt"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___pt"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___pt"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___pt"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___pt"
    }]
  }, {
    path: "/pt/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___pt"
    }]
  }, {
    path: "/pt/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___pt"
    }]
  }, {
    path: "/pt/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___pt"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___pt"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___pt"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___pt"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___pt"
    }]
  }, {
    path: "/pt/userCenter",
    component: _725bb279,
    name: "userCenter___pt",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___pt"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___pt"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___pt"
    }]
  }, {
    path: "/ro/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ro"
    }]
  }, {
    path: "/ro/all",
    component: _dca6ec8e,
    name: "all___ro"
  }, {
    path: "/ro/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ro"
  }, {
    path: "/ro/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ro"
    }]
  }, {
    path: "/ro/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ro"
    }]
  }, {
    path: "/ro/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ro"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ro"
    }]
  }, {
    path: "/ro/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ro"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ro"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ro"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ro"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ro"
    }]
  }, {
    path: "/ro/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ro"
    }]
  }, {
    path: "/ro/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ro"
    }]
  }, {
    path: "/ro/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ro"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ro"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ro"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ro"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ro"
    }]
  }, {
    path: "/ro/userCenter",
    component: _725bb279,
    name: "userCenter___ro",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ro"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ro"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ro"
    }]
  }, {
    path: "/ru/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___ru"
    }]
  }, {
    path: "/ru/all",
    component: _dca6ec8e,
    name: "all___ru"
  }, {
    path: "/ru/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___ru"
  }, {
    path: "/ru/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___ru"
    }]
  }, {
    path: "/ru/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___ru"
    }]
  }, {
    path: "/ru/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___ru"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___ru"
    }]
  }, {
    path: "/ru/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___ru"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___ru"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___ru"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___ru"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___ru"
    }]
  }, {
    path: "/ru/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___ru"
    }]
  }, {
    path: "/ru/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___ru"
    }]
  }, {
    path: "/ru/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___ru"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___ru"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___ru"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___ru"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___ru"
    }]
  }, {
    path: "/ru/userCenter",
    component: _725bb279,
    name: "userCenter___ru",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___ru"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___ru"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___ru"
    }]
  }, {
    path: "/se/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___se"
    }]
  }, {
    path: "/se/all",
    component: _dca6ec8e,
    name: "all___se"
  }, {
    path: "/se/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___se"
  }, {
    path: "/se/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___se"
    }]
  }, {
    path: "/se/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___se"
    }]
  }, {
    path: "/se/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___se"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___se"
    }]
  }, {
    path: "/se/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___se"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___se"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___se"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___se"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___se"
    }]
  }, {
    path: "/se/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___se"
    }]
  }, {
    path: "/se/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___se"
    }]
  }, {
    path: "/se/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___se"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___se"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___se"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___se"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___se"
    }]
  }, {
    path: "/se/userCenter",
    component: _725bb279,
    name: "userCenter___se",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___se"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___se"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___se"
    }]
  }, {
    path: "/th/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___th"
    }]
  }, {
    path: "/th/all",
    component: _dca6ec8e,
    name: "all___th"
  }, {
    path: "/th/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___th"
  }, {
    path: "/th/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___th"
    }]
  }, {
    path: "/th/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___th"
    }]
  }, {
    path: "/th/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___th"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___th"
    }]
  }, {
    path: "/th/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___th"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___th"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___th"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___th"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___th"
    }]
  }, {
    path: "/th/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___th"
    }]
  }, {
    path: "/th/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___th"
    }]
  }, {
    path: "/th/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___th"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___th"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___th"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___th"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___th"
    }]
  }, {
    path: "/th/userCenter",
    component: _725bb279,
    name: "userCenter___th",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___th"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___th"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___th"
    }]
  }, {
    path: "/tr/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___tr"
    }]
  }, {
    path: "/tr/all",
    component: _dca6ec8e,
    name: "all___tr"
  }, {
    path: "/tr/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___tr"
  }, {
    path: "/tr/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___tr"
    }]
  }, {
    path: "/tr/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___tr"
    }]
  }, {
    path: "/tr/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___tr"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___tr"
    }]
  }, {
    path: "/tr/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___tr"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___tr"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___tr"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___tr"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___tr"
    }]
  }, {
    path: "/tr/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___tr"
    }]
  }, {
    path: "/tr/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___tr"
    }]
  }, {
    path: "/tr/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___tr"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___tr"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___tr"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___tr"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___tr"
    }]
  }, {
    path: "/tr/userCenter",
    component: _725bb279,
    name: "userCenter___tr",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___tr"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___tr"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___tr"
    }]
  }, {
    path: "/tw/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___tw"
    }]
  }, {
    path: "/tw/all",
    component: _dca6ec8e,
    name: "all___tw"
  }, {
    path: "/tw/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___tw"
  }, {
    path: "/tw/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___tw"
    }]
  }, {
    path: "/tw/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___tw"
    }]
  }, {
    path: "/tw/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___tw"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___tw"
    }]
  }, {
    path: "/tw/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___tw"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___tw"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___tw"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___tw"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___tw"
    }]
  }, {
    path: "/tw/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___tw"
    }]
  }, {
    path: "/tw/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___tw"
    }]
  }, {
    path: "/tw/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___tw"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___tw"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___tw"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___tw"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___tw"
    }]
  }, {
    path: "/tw/userCenter",
    component: _725bb279,
    name: "userCenter___tw",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___tw"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___tw"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___tw"
    }]
  }, {
    path: "/vi/ad",
    component: _1f8bf3c8,
    children: [{
      path: "",
      component: _c1cef0c2,
      name: "ad___vi"
    }]
  }, {
    path: "/vi/all",
    component: _dca6ec8e,
    name: "all___vi"
  }, {
    path: "/vi/bigo-streamer",
    component: _7d38333c,
    name: "bigo-streamer___vi"
  }, {
    path: "/vi/classify",
    component: _2f646186,
    children: [{
      path: "",
      component: _d9c19800,
      name: "classify___vi"
    }]
  }, {
    path: "/vi/crushme",
    component: _61a1fe6a,
    children: [{
      path: "",
      component: _4ecc8d6d,
      name: "crushme___vi"
    }]
  }, {
    path: "/vi/games",
    component: _cc925750,
    children: [{
      path: "",
      component: _358e8e4a,
      name: "games___vi"
    }, {
      path: ":id",
      component: _11c53603,
      name: "games-id___vi"
    }]
  }, {
    path: "/vi/jp",
    component: _003ebdbf,
    children: [{
      path: "",
      component: _41e08dfc,
      name: "jp___vi"
    }, {
      path: "about-us",
      component: _c8feba44,
      name: "jp-about-us___vi"
    }, {
      path: "contact-us",
      component: _7e97262a,
      name: "jp-contact-us___vi"
    }, {
      path: "news",
      component: _6ae30e96,
      name: "jp-news___vi"
    }, {
      path: "news/:id",
      component: _77efbe7e,
      name: "jp-news-id___vi"
    }]
  }, {
    path: "/vi/jp2",
    component: _07b0a383,
    children: [{
      path: "",
      component: _41073bc6,
      name: "jp2___vi"
    }]
  }, {
    path: "/vi/show",
    component: _5a1823b6,
    children: [{
      path: "",
      component: _dca6ec8e,
      name: "show___vi"
    }]
  }, {
    path: "/vi/ssrmobile",
    component: _67c15c6a,
    children: [{
      path: "",
      component: _5007d7e4,
      name: "ssrmobile___vi"
    }, {
      path: "room/game",
      component: _7c2fdbe2,
      name: "ssrmobile-room-game___vi"
    }, {
      path: "room/mixins",
      component: _12ab094d,
      name: "ssrmobile-room-mixins___vi"
    }, {
      path: "room/show",
      component: _5d1e2526,
      name: "ssrmobile-room-show___vi"
    }, {
      path: "user/:id?",
      component: _ec543e2c,
      name: "ssrmobile-user-id___vi"
    }]
  }, {
    path: "/vi/userCenter",
    component: _725bb279,
    name: "userCenter___vi",
    children: [{
      path: "edit",
      component: _d81d9ce0,
      name: "userCenter-edit___vi"
    }, {
      path: "setting",
      component: _6981f78c,
      name: "userCenter-setting___vi"
    }, {
      path: ":id?",
      component: _329c1ba4,
      name: "userCenter-id___vi"
    }]
  }, {
    path: "/ar/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ar"
  }, {
    path: "/ar/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ar"
  }, {
    path: "/ar/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ar"
  }, {
    path: "/ar/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ar"
  }, {
    path: "/cn/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___cn"
  }, {
    path: "/cn/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___cn"
  }, {
    path: "/cn/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___cn"
  }, {
    path: "/cn/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___cn"
  }, {
    path: "/de/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___de"
  }, {
    path: "/de/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___de"
  }, {
    path: "/de/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___de"
  }, {
    path: "/de/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___de"
  }, {
    path: "/en/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___en"
  }, {
    path: "/en/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___en"
  }, {
    path: "/en/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___en"
  }, {
    path: "/en/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___en"
  }, {
    path: "/es/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___es"
  }, {
    path: "/es/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___es"
  }, {
    path: "/es/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___es"
  }, {
    path: "/es/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___es"
  }, {
    path: "/fr/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___fr"
  }, {
    path: "/fr/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___fr"
  }, {
    path: "/fr/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___fr"
  }, {
    path: "/fr/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___fr"
  }, {
    path: "/hi/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___hi"
  }, {
    path: "/hi/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___hi"
  }, {
    path: "/hi/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___hi"
  }, {
    path: "/hi/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___hi"
  }, {
    path: "/id/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___id"
  }, {
    path: "/id/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___id"
  }, {
    path: "/id/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___id"
  }, {
    path: "/id/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___id"
  }, {
    path: "/it/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___it"
  }, {
    path: "/it/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___it"
  }, {
    path: "/it/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___it"
  }, {
    path: "/it/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___it"
  }, {
    path: "/ja/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ja"
  }, {
    path: "/ja/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ja"
  }, {
    path: "/ja/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ja"
  }, {
    path: "/ja/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ja"
  }, {
    path: "/ko/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ko"
  }, {
    path: "/ko/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ko"
  }, {
    path: "/ko/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ko"
  }, {
    path: "/ko/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ko"
  }, {
    path: "/mm/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___mm"
  }, {
    path: "/mm/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___mm"
  }, {
    path: "/mm/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___mm"
  }, {
    path: "/mm/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___mm"
  }, {
    path: "/ms/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ms"
  }, {
    path: "/ms/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ms"
  }, {
    path: "/ms/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ms"
  }, {
    path: "/ms/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ms"
  }, {
    path: "/nl/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___nl"
  }, {
    path: "/nl/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___nl"
  }, {
    path: "/nl/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___nl"
  }, {
    path: "/nl/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___nl"
  }, {
    path: "/pl/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___pl"
  }, {
    path: "/pl/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___pl"
  }, {
    path: "/pl/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___pl"
  }, {
    path: "/pl/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___pl"
  }, {
    path: "/pt/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___pt"
  }, {
    path: "/pt/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___pt"
  }, {
    path: "/pt/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___pt"
  }, {
    path: "/pt/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___pt"
  }, {
    path: "/ro/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ro"
  }, {
    path: "/ro/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ro"
  }, {
    path: "/ro/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ro"
  }, {
    path: "/ro/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ro"
  }, {
    path: "/ru/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___ru"
  }, {
    path: "/ru/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___ru"
  }, {
    path: "/ru/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___ru"
  }, {
    path: "/ru/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___ru"
  }, {
    path: "/se/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___se"
  }, {
    path: "/se/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___se"
  }, {
    path: "/se/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___se"
  }, {
    path: "/se/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___se"
  }, {
    path: "/th/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___th"
  }, {
    path: "/th/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___th"
  }, {
    path: "/th/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___th"
  }, {
    path: "/th/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___th"
  }, {
    path: "/tr/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___tr"
  }, {
    path: "/tr/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___tr"
  }, {
    path: "/tr/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___tr"
  }, {
    path: "/tr/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___tr"
  }, {
    path: "/tw/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___tw"
  }, {
    path: "/tw/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___tw"
  }, {
    path: "/tw/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___tw"
  }, {
    path: "/tw/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___tw"
  }, {
    path: "/vi/bigo-streamer/android",
    component: _7d38333c,
    name: "bigo-streamer-android___vi"
  }, {
    path: "/vi/bigo-streamer/connector",
    component: _7d38333c,
    name: "bigo-streamer-connector___vi"
  }, {
    path: "/vi/bigo-streamer/ios",
    component: _7d38333c,
    name: "bigo-streamer-ios___vi"
  }, {
    path: "/vi/bigo-streamer/obs",
    component: _7d38333c,
    name: "bigo-streamer-obs___vi"
  }, {
    path: "/ar/sid/:sid",
    component: _631ef7c0,
    name: "sid___ar"
  }, {
    path: "/cn/sid/:sid",
    component: _631ef7c0,
    name: "sid___cn"
  }, {
    path: "/de/sid/:sid",
    component: _631ef7c0,
    name: "sid___de"
  }, {
    path: "/en/sid/:sid",
    component: _631ef7c0,
    name: "sid___en"
  }, {
    path: "/es/sid/:sid",
    component: _631ef7c0,
    name: "sid___es"
  }, {
    path: "/fr/sid/:sid",
    component: _631ef7c0,
    name: "sid___fr"
  }, {
    path: "/hi/sid/:sid",
    component: _631ef7c0,
    name: "sid___hi"
  }, {
    path: "/id/sid/:sid",
    component: _631ef7c0,
    name: "sid___id"
  }, {
    path: "/it/sid/:sid",
    component: _631ef7c0,
    name: "sid___it"
  }, {
    path: "/ja/sid/:sid",
    component: _631ef7c0,
    name: "sid___ja"
  }, {
    path: "/ko/sid/:sid",
    component: _631ef7c0,
    name: "sid___ko"
  }, {
    path: "/mm/sid/:sid",
    component: _631ef7c0,
    name: "sid___mm"
  }, {
    path: "/ms/sid/:sid",
    component: _631ef7c0,
    name: "sid___ms"
  }, {
    path: "/nl/sid/:sid",
    component: _631ef7c0,
    name: "sid___nl"
  }, {
    path: "/pl/sid/:sid",
    component: _631ef7c0,
    name: "sid___pl"
  }, {
    path: "/pt/sid/:sid",
    component: _631ef7c0,
    name: "sid___pt"
  }, {
    path: "/ro/sid/:sid",
    component: _631ef7c0,
    name: "sid___ro"
  }, {
    path: "/ru/sid/:sid",
    component: _631ef7c0,
    name: "sid___ru"
  }, {
    path: "/se/sid/:sid",
    component: _631ef7c0,
    name: "sid___se"
  }, {
    path: "/th/sid/:sid",
    component: _631ef7c0,
    name: "sid___th"
  }, {
    path: "/tr/sid/:sid",
    component: _631ef7c0,
    name: "sid___tr"
  }, {
    path: "/tw/sid/:sid",
    component: _631ef7c0,
    name: "sid___tw"
  }, {
    path: "/vi/sid/:sid",
    component: _631ef7c0,
    name: "sid___vi"
  }, {
    path: "/ar/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ar"
  }, {
    path: "/cn/:bigoid",
    component: _631ef7c0,
    name: "bigoid___cn"
  }, {
    path: "/de/:bigoid",
    component: _631ef7c0,
    name: "bigoid___de"
  }, {
    path: "/en/:bigoid",
    component: _631ef7c0,
    name: "bigoid___en"
  }, {
    path: "/es/:bigoid",
    component: _631ef7c0,
    name: "bigoid___es"
  }, {
    path: "/fr/:bigoid",
    component: _631ef7c0,
    name: "bigoid___fr"
  }, {
    path: "/hi/:bigoid",
    component: _631ef7c0,
    name: "bigoid___hi"
  }, {
    path: "/id/:bigoid",
    component: _631ef7c0,
    name: "bigoid___id"
  }, {
    path: "/it/:bigoid",
    component: _631ef7c0,
    name: "bigoid___it"
  }, {
    path: "/ja/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ja"
  }, {
    path: "/ko/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ko"
  }, {
    path: "/mm/:bigoid",
    component: _631ef7c0,
    name: "bigoid___mm"
  }, {
    path: "/ms/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ms"
  }, {
    path: "/nl/:bigoid",
    component: _631ef7c0,
    name: "bigoid___nl"
  }, {
    path: "/pl/:bigoid",
    component: _631ef7c0,
    name: "bigoid___pl"
  }, {
    path: "/pt/:bigoid",
    component: _631ef7c0,
    name: "bigoid___pt"
  }, {
    path: "/ro/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ro"
  }, {
    path: "/ru/:bigoid",
    component: _631ef7c0,
    name: "bigoid___ru"
  }, {
    path: "/se/:bigoid",
    component: _631ef7c0,
    name: "bigoid___se"
  }, {
    path: "/sid/:sid",
    component: _631ef7c0,
    name: "sid___en___default"
  }, {
    path: "/th/:bigoid",
    component: _631ef7c0,
    name: "bigoid___th"
  }, {
    path: "/tr/:bigoid",
    component: _631ef7c0,
    name: "bigoid___tr"
  }, {
    path: "/tw/:bigoid",
    component: _631ef7c0,
    name: "bigoid___tw"
  }, {
    path: "/vi/:bigoid",
    component: _631ef7c0,
    name: "bigoid___vi"
  }, {
    path: "/",
    component: _2cdd59e9,
    children: [{
      path: "",
      component: _d1e1e4a8,
      name: "index___en___default"
    }]
  }, {
    path: "/:bigoid",
    component: _631ef7c0,
    name: "bigoid___en___default"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
